import { cn } from '#app/utils/misc.tsx'

/**
 * Decorative SVG line tracing exponential growth.
 * Animates draw-on once on mount via the .animate-curve-draw class
 * (defined in marketing.css).
 */
export function CompoundCurve({
	className,
	width = 200,
	height = 90,
	stroke = 'var(--m-ember)',
	tone = 'ink',
}: {
	className?: string
	width?: number
	height?: number
	stroke?: string
	tone?: 'ink' | 'cream'
}) {
	const strokeColor = tone === 'cream' ? 'var(--m-cream-ember)' : stroke
	return (
		<svg
			aria-hidden
			width={width}
			height={height}
			viewBox="0 0 200 90"
			className={cn('animate-curve-draw', className)}
		>
			<path
				d="M0 80 Q 30 78, 50 65 T 100 38 T 150 18 T 200 6"
				stroke={strokeColor}
				strokeWidth="1.6"
				fill="none"
				strokeLinecap="round"
			/>
			<circle cx="200" cy="6" r="3" fill={strokeColor} />
		</svg>
	)
}
